export const downloadFile = (data, parseData=true) => {
    const link = document.createElement('a')
    let s3_url = data;
    if (parseData) {
        s3_url = JSON.parse(data);
    }
    link.href = s3_url['url']
    document.body.appendChild(link)
    link.click()
}